import { useVisitDialog } from "./DialogContext";
import { VisitModalLayout } from "./VisitModalLayout";
import useImageUrl from "../../../../CustomHooks/useImageUrl";

VisitModalLayout.VisitSigns = function VisitSigns() {
  const { visit } = useVisitDialog();
  const { getImageUrl } = useImageUrl();
  return (
    <div className="visit-sign-container">
      <h3 className="signText">Signatures</h3>
      <div className="signImgWrap">
        <div className="px-5">
          <p className="w-24 h-24">
            <img src={getImageUrl(visit.ftSign)} alt="sign" />
          </p>
          <p>Service Engineer</p>
        </div>
        <div className="px-5">
          <p className="w-24 h-24">
            <img
              src={getImageUrl(visit.operatorSign)}
              alt="sign"
              className="w-24 h-24"
            />
          </p>
          <p>Operator</p>
        </div>
      </div>
    </div>
  );
};
